<template>
  <div class="container">
    <div class="author">
      <div class="avatar">
        <img :src="userInfo.avatar" alt />
      </div>
      <div class="authorInfo">
        <div class="name">
          <span>前端</span>
          {{ userInfo.showName }}
        </div>
        <div class="articleNum">
          文章：{{ articleCount }}
          <span>&nbsp;|&nbsp;</span>
          字数：{{ wordCount }}
        </div>
        <div>
          <span class="articleNum">
            访问人数：<span style="color:#969696">{{ userIpCount }}</span>
          </span>
        </div>
        <div class="singName" v-html="userInfo.singName"></div>
      </div>
    </div>
    <v-article
      :articleList="articleList"
      :articleCount="articleCount"
      :currentPage="currentPage"
      :pageNum="pageNum"
      :isLoading="isLoading"
      :nowTagName="nowTagName"
      @getArticleList="getArticleList"
      @showMessage="showMessage"
      @toTag="toTag"
    ></v-article>
    <v-sidebar
      :categories="categories"
      :tags="tags"
      :nowCategorie="nowCategorie"
      :nowTagName="nowTagName"
      @getColumnArticle="getColumnArticle"
      @toTag="toTag"
    ></v-sidebar>
  </div>
</template>
<script>
import Article from "@/components/common/article/article";
import Sidebar from "@/components/common/sidebar/sidebar";
export default {
  components: {
    "v-article": Article,
    "v-sidebar": Sidebar
  },
  data() {
    return {};
  },
  props: {
    articleList: {
      type: Array,
      default: () => []
    },
    articleCount: {
      type: Number,
      default: 0
    },
    wordCount: {
      type: Number,
      default: 0
    },
    userIpCount: {
      type: Number,
      default: 0
    },
    currentPage: {
      type: Number,
      default: 1
    },
    pageNum: {
      type: Number,
      default: 10
    },
    userInfo: {
      type: Object,
      default: {}
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    categories: {
      type: Array,
      default: () => []
    },
    nowCategorie: {
      type: String,
      default: ""
    },
    tags: {
      type: Array,
      default: () => []
    },
    nowTagName: {
      type: String,
      default: ""
    }
  },
  methods: {
    getColumnArticle(col) {
      //获取分类相关的文章
      this.$emit("getColumnArticle", col);
    },
    toTag(itemTag) {
      this.$emit("getTagArticle", itemTag);
    },
    getArticleList(data) {
      this.$emit("getArticleList", data);
    },
    showMessage(msg) {
      this.$emit("showMessage", msg);
    }
  }
};
</script>

<style lang="less" scoped>
@import url("../../assets/style/common.less");
@main: #26a69a;
.container {
  width: 1024px;
  position: relative;
  margin: auto;
  .clearfixMixin();
  .emptyBox {
    height: 90px;
    width: 100%;
    position: fixed;
    z-index: 989;
    background-color: #fff;
    top: 0;
    left: 0;
  }
  .author {
    width: 75%;
    margin-top: 30px;
    padding-bottom: 15px;
    .clearfixMixin();
    .avatar {
      width: 70px;
      height: 70px;
      background-color: #fff;
      float: left;
      margin: 7px 18px 0 0;
      overflow: hidden;
      img {
        height: 100%;
        border-radius: 100%;
      }
    }
    .authorInfo {
      float: left;
      padding-top: 6px;
      width: 660px;
      .name {
        margin-bottom: 10px;
        .clearfixMixin();
        span {
          float: left;
          width: 30px;
          height: 17px;
          border: 1px solid @main;
          border-radius: 4px;
          margin-right: 10px;
          font-size: 12px;
          color: @main;
          line-height: 17px;
          text-align: center;
        }
      }
      .articleNum {
        color: #969696;
        margin-bottom: 10px;
        span {
          color: #dbdbdb;
        }
      }
      .singName {
        color: #777777;
        line-height: 20px;
        margin-top: 10px;
        .txt-cut(1);
      }
    }
  }
  .error-wrapper {
    width: 75%;
  }
}
@media (max-width: 1024px) {
  .container {
    width: 100%;
    .author {
      width: 100%;
      padding: 0 20px;
      margin: 15px 0;
      box-sizing: border-box;
      .avatar {
        display: none;
      }
      .authorInfo {
        width: auto;
      }
    }
    .error-wrapper {
      width: 100%;
    }
    & > div {
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?5203ced8